export const MOVE_NEXT = "MOVE_NEXT";
export const MOVE_PREV = "MOVE_PREV";
export const SET_CURRENT_STEP = "SET_CURRENT_STEP";
export const SET_NUMBER_OF_STEPS = "SET_NUMBER_OF_STEPS";
export const SET_WIZARD_FIELDS = "SET_WIZARD_FIELDS";
export const SET_CURRENT_STEP_ERRORS = "SET_CURRENT_STEP_ERRORS";
export const SET_VALUES = "SET_VALUES";
